

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import { setCache } from '../../General/Actions.js';
import Network from '../../Utils/network.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import TableComponent from '../../Utils/tableComponent.js';
import SliderModal from '../../Utils/sliderModal.js';
import Swal from 'sweetalert2';
import moment from 'moment';
import NoDataFound from '../../Utils/noDataFound.js';

class RewardsPageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            billingName: "",
            contactNumber: "",
            accountId:"",
            currentTab: "rewards",
            isAlreadyRegisteredForRewards: false,
            rewardPointsFromLMS: 0,
            rewardsTermsAndConditionsVisible: false,
            rewardsTransactionsData: {
                data: []
            },
            addonArr: [],
            allAddonDetails: [],
            contactDetails: {}
        }
    }

    componentDidMount() {
        this.initializeServiceListFromCache(this.props.cache.subscriberInfo);
        var dataToSend = {
            "serviceId": this.props.cache.serviceInfo.serviceId,
            "actionType": "add_on_add"
        }

        Network.executeAxios("eligibilityValidation", "POST", dataToSend, (validationResponse) => {
            
            if (validationResponse && validationResponse.BillingSystem && validationResponse.BillingSystem.response
                && validationResponse.BillingSystem.response.optionlist[0] && validationResponse.BillingSystem.response.optionlist[0].response_code) {
                var resultCode = validationResponse.BillingSystem.response.optionlist[0].response_code;
                var resultDesc = validationResponse.BillingSystem.response.optionlist[0].response_description
                if (resultCode === "0") {
                        // window.addEventListener('scroll', this.handleScroll);
                        this.initialiseQuerySubscriber();
                        this.getRewardPoints();
                } else {
                    this.setState({ isLoading: false })
                    Swal.fire(resultDesc, "", "");
                }
            } else {
                this.setState({ isLoading: false })
                Swal.fire(this.props.locales.LoginPageUnableToProcessSwal, "", "");
            }
            })
    }

    initializeServiceListFromCache(receivedSubscriberInfoResponse) {
        var reduxCache = this.props.cache;
        var maBalance = "0";
        var serviceCode = ""
        var serviceName = ""
        var currentCreditLimit=0;
        try {
            var receivedResponse = reduxCache.querySubscriberResponse;
            var params = receivedResponse.profile_info.basic_details;
            var finalContactNumber = "";
            var finalEmailId = "";
            var finalFirstName = "";
            var finalLastName = "";
            var finalProfileId = "";

            for (var i = 0; i < params.length; i++) {
                if (params[i].id === "first_name") {
                    finalFirstName = params[i].value;
                }
                if (params[i].id === "last_name") {
                    finalLastName = params[i].value;
                }
                if (params[i].id === "contact_number_1") {
                    finalContactNumber = params[i].value;
                }
                if (params[i].id === "contact_email_id") {
                    finalEmailId = params[i].value;
                }
                if (params[i].id === "profile_id") {
                    finalProfileId = params[i].value;
                }
            }
            this.state.firstName = finalFirstName
            this.state.lastName = finalLastName
            this.state.contactEmailAddress = finalEmailId
            this.state.contactNumber = finalContactNumber
            this.state.profileId = finalProfileId

        } catch (err) {

        }
        try {
            var serviceParams = receivedSubscriberInfoResponse.service_info.basic_details;
            var finalPlanId = "";
            var finalPlanName = "";
        
            for (var j = 0; j < serviceParams.length; j++) {
                if (serviceParams[j].id === "rate_plan_id") {
                    finalPlanId = serviceParams[j].value;
                }
                if (serviceParams[j].id === "rate_plan_name") {
                    finalPlanName = serviceParams[j].value;
                }
                if (serviceParams[j].id === "maBalance") {
                    maBalance = serviceParams[j].value
                } 
                if (serviceParams[j].id === "service_code") {
                    serviceCode = serviceParams[j].value
                }
                if (serviceParams[j].id === "currentCreditLimit") {
                    currentCreditLimit = serviceParams[j].value
                } 

                if (serviceParams[j].id === "service_name") {
                    serviceName = serviceParams[j].value
                }
 
            }
            this.state.currentPlanId = this.props.cache.currentPlanDetails.planId
            this.state.currentPlanName = finalPlanName
            
            console.log("maBalance>>>>>",maBalance)
        } catch (err) {

        }
        try{
            var accountData = receivedResponse.account_info.basic_details;
            var accountId = "";
            for (var k = 0; k < accountData.length; k++) {
                if (accountData[k].id === "account_id") {
                    accountId = accountData[k].value;
                }
            }
            this.state.accountId = accountId
        } catch(err){
            accountData=[]
        }

        var contactDetails = {}
        contactDetails["firstName"] = this.state.firstName;
        contactDetails["lastName"] = this.state.lastName;
        contactDetails["contactEmailAddress"] = this.state.contactEmailAddress;
        contactDetails["contactNumber"] = this.state.contactNumber;
        contactDetails["profileId"] = this.state.profileId;
        contactDetails["accountId"] = this.state.accountId;
        contactDetails["currentPlanId"] = this.state.currentPlanId;
        contactDetails["currentPlanName"] = this.state.currentPlanName;
        contactDetails["serviceId"] = this.props.cache.serviceInfo.serviceId;
        contactDetails["serviceCode"] = serviceCode;
        contactDetails["serviceName"] = serviceName;
        contactDetails["currentCreditLimit"] = currentCreditLimit;
       
        this.setState({contactDetails: contactDetails})

    }

    getRewardPoints() {
        var serviceId = this.props.cache.serviceInfo.serviceId;
        Network.executeAxios("getRewardsData", "POST", { "serviceId": serviceId }, (rewardsData) => {
            if (rewardsData.result_code === "0") {  // user already registered in lms
                this.setState({ isAlreadyRegisteredForRewards: true })
                if (rewardsData && rewardsData.loyalty_info && rewardsData.loyalty_info.rewardPoints) {
                    this.setState({ rewardPointsFromLMS: rewardsData.loyalty_info.rewardPoints })
                    console.log("Total Rewards points >> ", rewardsData.loyalty_info.rewardPoints)
                    console.log("Loyality ID >> ", rewardsData.loyalty_info.loyaltyID)
                    Network.executeAxios("getRewardsTransactions", "POST", { "serviceId": serviceId, "loyalityId": rewardsData.loyalty_info.loyaltyID }, (rewardsTransactions) => {
                        console.log("popuplate rewards transactions >> ", rewardsTransactions)
                        var rewardsTransactionsDataArr = [];
                        var payLoadForTransactions = {
                            totalRecords: 0,
                            data: ""
                        }
                        if (rewardsTransactions && rewardsTransactions.result_code == 0) {
                            rewardsTransactionsDataArr = rewardsTransactions.loyalty_information.redemption_details
                        }

                        for(var k=0; k<rewardsTransactionsDataArr.length; k++){
                            var currentObj = rewardsTransactionsDataArr[k];
                            if(currentObj.date){
                                currentObj["date"] = GeneralUtils.formatDateToStandardForm(currentObj.date,"DD-MM-YYYY hh:mm:ss","MM/DD/YYYY")
                            }
                            if(currentObj.expiry_date){
                                currentObj["expiry_date"] = GeneralUtils.formatDateToStandardForm(currentObj.expiry_date,"YYYY-MM-DD hh:mm:ss","MM/DD/YYYY")
                            }
                        }

                        payLoadForTransactions = {
                            totalRecords: rewardsTransactionsDataArr.length,
                            data: rewardsTransactionsDataArr
                        }
                        this.setState({ rewardsTransactionsData: payLoadForTransactions, serviceId: serviceId})


                        var headers = {};
                        headers["isRedeemable"] = "true"; 
                        headers["CustomerType"] = this.props.userDetails.customerType;
                        headers["CustomerCategory"] = this.props.userDetails.customerCategory;
                        headers["CustomerSubCategory"] = this.props.userDetails.customerSubCategory;
                        headers["Channel"] = this.props.locales.channelIdForSCM;
                        headers["CONNECTIONTYPE"] = this.props.cache.serviceInfo.connectionType;
                

                        if (this.props.configurationValues) {
                            headers["SalesChannel"] = this.props.configurationValues.salesChannelForRedeemableAddons;
                            headers["isRedeemablePoints"] = this.props.configurationValues.isRedeemablePointsForRedeemableAddons;
                            headers["addonTypeForRedeemableAddons"] = this.props.configurationValues.addonTypeForRedeemableAddons;
                        }

                        
                        window.addEventListener('resize', this.updateWindowDimensions);
                        var planId = "";
                        if(this.props.cache.currentPlanDetails && this.props.cache.currentPlanDetails.planId) planId = this.props.cache.currentPlanDetails.planId
                                var dataToSendForEligibilityOffer = {
                                    "baseOfferId": planId,
                                    "header": headers
                                }
                                
                                Network.executeAxios("fetchEligibilityOffers", "POST", dataToSendForEligibilityOffer, (response) => {
                                  
                                    Network.executeAxios("fetchAddons", "POST", {"pog": this.props.cache.serviceInfo.pog,  "header": headers} , (addonResponse) => {
                                        var finalAllAddonDetails = [];
                                        if (response && response[0]) {
                                            finalAllAddonDetails = response;
                                        }
                                        else {
                                            finalAllAddonDetails = []
                                        }
                                        this.initializeAlladdonDetails(finalAllAddonDetails, addonResponse)
                        
                                    
                                })
                            });
                    })
                } else {
                    this.setState({serviceId: serviceId, isLoading: false})
                }
            } else {
                console.log("user not registered in lms");
                this.setState({ isAlreadyRegisteredForRewards: false,serviceId: serviceId, isLoading: false })
            }
        })
    }

    initializeAlladdonDetails(receivedResponse, stdAddonResponse) {
        var stdAddonArr = []
        for (var p = 0; p < stdAddonResponse.length; p++) {
            if (stdAddonResponse[p].success) {
                for (var q = 0; q < stdAddonResponse[p].success.length; q++) {
                    stdAddonArr.push(stdAddonResponse[p].success[q]);
                }
            }
        }

        var eligibilityOffers = [];
        try {
            if (Array.isArray(receivedResponse)) {
                for (var x = 0; x < receivedResponse.length; x++) {
                    if(receivedResponse[x].eligibilityOffers)
                    eligibilityOffers.push(receivedResponse[x].eligibilityOffers)
                }
            }
        } catch (err) {
            eligibilityOffers = [];
        }

        var finaleligibilityOffers = []
        if(eligibilityOffers && eligibilityOffers.length > 0)
        finaleligibilityOffers = eligibilityOffers.reduce((r, e) => (r.push(...e), r), []);
       
        var finalProductOfferingsArray = [];
        for (var i = 0; i < finaleligibilityOffers.length; i++) {
            var productOfferingsArray = [];
            try {
                if (finaleligibilityOffers[i].productOfferings) {
                    if (finaleligibilityOffers[i].maxQuantity) {
                        var productOfferingsArrayNew = finaleligibilityOffers[i].productOfferings;
                        if (productOfferingsArrayNew.length > 0) {
                            for (var j = 0; j < productOfferingsArrayNew.length; j++) {
                                productOfferingsArrayNew[j].eligibilityType = finaleligibilityOffers[i].eligibilityType.id;
                            }
                        } else {
                            console.log("productOfferingsArrayNew length 0")
                        }
                    }
                    if (finaleligibilityOffers[i].productOfferings) {
                        productOfferingsArray.push(finaleligibilityOffers[i].productOfferings);
                        var productOfferingsArrayUpdated = productOfferingsArray.reduce((r, e) => (r.push(...e), r), []);
                        var maxQuantity = "100000000000000"
                        if (finaleligibilityOffers[i].maxQuantity) {
                            maxQuantity = finaleligibilityOffers[i].maxQuantity
                        }

                        let temp = {
                            "groupMaxQuantity": maxQuantity,
                            "groupMinQuantity": finaleligibilityOffers[i].minQuantity,
                            "productOfferings": productOfferingsArrayUpdated
                        }
                        finalProductOfferingsArray.push(temp)
                    }
                }
            }
            catch (err) { }
        }

        if (stdAddonArr.length > 0) {
            let tempObj = {
                "groupMaxQuantity": "1000000000000000",
                "groupMinQuantity": "0",
                "productOfferings": stdAddonArr
            }
            finalProductOfferingsArray.push(tempObj)
        }

        console.log("finalProductOfferingsArray", finalProductOfferingsArray)
        this.state.allAddonDetails = finalProductOfferingsArray;
       // document.body.classList.add('modal-open');
        this.setState({ isLoading: false })
    }



    populateAllRedeemablePlans() {
        var isAddonPresent = false;
        const allAddonDetails = this.state.allAddonDetails.map((itemArray, keyCheck) => {
            var currentItemArray = itemArray.productOfferings;
            return currentItemArray.map((item, key) => {
                try {
                    var productPrice = {}
                    if (item.productOfferingPrice[0]) {
                        for (var i = 0; i < item.productOfferingPrice.length; i++) {
                            if (item.productOfferingPrice[i] && item.productOfferingPrice[i].priceCategory) {
                                if (item.productOfferingPrice[i].priceCategory.id === "0") {
                                    productPrice = item.productOfferingPrice[i];
                                }
                            }

                        }
                    }

                    var rewardPoint = ""
                    if (productPrice.price) {
                        rewardPoint = parseFloat(productPrice.price) * parseInt(this.state.redemptionPoint)
                    }

                    var packageAmount = ""
                    var packageAmount_sup = ""
                    try {
                        if (productPrice.price) {
                            var price = productPrice.price;
                        }
                        price = price.split(".");
                        packageAmount = price[0]
                        if (price.length > 1) {
                            packageAmount_sup = price[1];
                        } else {
                            packageAmount_sup = "00"
                        }
                    } catch (err) {
                        packageAmount = 0
                        packageAmount_sup = "00"
                    }

                    var contextValue = ""
                    try {
                        if (item.productOfferingPrice[0].rules[0].conditions[0]) {
                            for (var y = 0; y < item.productOfferingPrice[0].rules[0].conditions.length; y++) {
                                if (item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].name === "VideoFormat") {
                                    contextValue = item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].value
                                }
                            }

                        }
                    } catch (err) {
                        contextValue = ""
                    }

                    var productSubtype = {}
                    try {
                        if (item.productSpecifications[0]) {
                            productSubtype = item.productSpecifications[0].subType;
                        }
                    } catch (err) {
                        productSubtype = {}
                    }
                    var poType = {}
                    try {
                        if (item.productSpecifications[0]) {
                            poType = item.productSpecifications[0].type;
                        }
                    } catch (err) {
                        poType = {}
                    }

                    var productSpecifications = {}
                    try {
                        if (item.productSpecifications[0]) {
                            productSpecifications = item.productSpecifications[0];
                        }
                    } catch (err) {
                        productSpecifications = {}
                    }



                    var productOfferGroup = {}
                    try {
                        if (item.productOfferGroup) {
                            productOfferGroup = item.productOfferGroup;
                        }
                    } catch (err) {
                        productOfferGroup = {}
                    }

                    var connectionType = "POSTPAID"
                    if (this.props.cache.currentPlanDetails.connectionType === this.props.locales.connectionTypeForPrepaid) { connectionType = "PREPAID" }

                    var skipSom = "false";
                    var cfss = []
                    try {
                       for(var m = 0; m < item.productSpecifications.length; m++){
                           var currentPS = item.productSpecifications[m];
                           for(var n = 0; n< currentPS.cfss.length; n++){
                                var currentObjCfss = currentPS.cfss[n];
                                if(currentPS.releationships.length > 0){
                                    for(var o = 0; o < currentPS.releationships.length; o++){
                                        var relationObj =  currentPS.releationships[0];
                                        if(relationObj && relationObj.targetObject && currentObjCfss.id === relationObj.targetObject.id){
                                            if(relationObj && relationObj.skipSOM && relationObj.skipSOM == "true"){
                                                skipSom = "true";
                                            }
                                        }
                                    }
                                }
                                currentObjCfss["skip_som"] = skipSom
                                cfss.push(currentObjCfss)
                                delete currentObjCfss.validFor
                           }
                       }
                    } catch (err) {
                        cfss = []
                    }

                    var cfssArray = []
                    for (var x = 0; x < cfss.length; x++) {
                        let temp = {
                            "id": cfss[x].id,
                            "name": cfss[x].name,
                            "href": cfss[x].href,
                            "service_type": cfss[x].serviceType,
                            "service_class": cfss[x].serviceClass,
                            "transport_type": cfss[x].transportType,
                            "service_category": cfss[x].serviceCategory,
                            "characteristics": cfss[x].characteristics,
                            "skip_som": cfss[x].skip_som
                        }
                        cfssArray.push(temp);
                    }

                    var isRedeemable = false;
                    for (var y = 0; y < cfssArray.length; y++) {
                        if (cfssArray[y].characteristics) {
                            var characteristics = cfssArray[y].characteristics;
                            for (var k = 0; k < characteristics.length; k++) {
                                if (characteristics[k].name && characteristics[k].value) {
                                    if (characteristics[k].name == "isRedeemable" && characteristics[k].value == "true") {
                                        isRedeemable = true;
                                    }
                                }
                            }
                        }
                    }

                    var isMakePaymentAdjustment = false;
                    var PaymentAmount = "0";
                    for (var y = 0; y < cfssArray.length; y++) {
                        if (cfssArray[y].characteristics) {
                            var characteristics = cfssArray[y].characteristics;
                            for (var k = 0; k < characteristics.length; k++) {
                                if (characteristics[k].name && characteristics[k].value) {
                                    if (characteristics[k].name == "MakePayment" && characteristics[k].value == "true") {
                                        isMakePaymentAdjustment = true;
                                    }
                                    if(isMakePaymentAdjustment){
                                        if (characteristics[k].name == "PaymentAmount" && characteristics[k].value) {
                                            PaymentAmount = characteristics[k].value;
                                        }
                                    }
                                }
                            }
                        }
                    }


                    var isMakeAdjustment = false;
                    var adjustmentAmount = "0";
                    for (var y = 0; y < cfssArray.length; y++) {
                        if (cfssArray[y].characteristics) {
                            var characteristics = cfssArray[y].characteristics;
                            for (var k = 0; k < characteristics.length; k++) {
                                if (characteristics[k].name && characteristics[k].value) {
                                    if (characteristics[k].name == "MakeAdjustment" && characteristics[k].value == "true") {
                                        isMakeAdjustment = true;
                                    }
                                    if(isMakeAdjustment){
                                        if (characteristics[k].name == "AdjustmentAmount" && characteristics[k].value) {
                                            adjustmentAmount = characteristics[k].value;
                                        }
                                    }
                                }
                            }
                        }
                    }




                    var MinLoyaltyPoints = "0";
                    for (var y = 0; y < cfssArray.length; y++) {
                        if (cfssArray[y].characteristics) {
                            var characteristics = cfssArray[y].characteristics;
                            for (var k = 0; k < characteristics.length; k++) {
                                if (characteristics[k].name && characteristics[k].value) {
                                    if (characteristics[k].name == "MinLoyaltyPoints") {
                                        MinLoyaltyPoints = characteristics[k].value
                                    }
                                }
                            }
                        }
                    }

                    //adding CFSS char value
                    var cfssEndDateInYears = "2";
                    if(this.props.configurationValues){
                        cfssEndDateInYears = this.props.configurationValues.cfssEndDateInYears
                    }

                    for (var y = 0; y < cfssArray.length; y++) {
                        if (cfssArray[y].characteristics) {
                            var characteristics = cfssArray[y].characteristics;
                            for (var k = 0; k < characteristics.length; k++) {
                                if (characteristics[k].name) {
                                    if(characteristics[k].name === "START_DATE"){
                                        characteristics[k]["value"] =  moment().format("DD-MM-YYYY HH:mm:ss")
                                    }
                                    if(characteristics[k].name === "END_DATE"){
                                        characteristics[k]["value"] = moment().add(cfssEndDateInYears, 'years').format("DD-MM-YYYY HH:mm:ss")
                                    }
                                    if(characteristics[k].name === "NAME"){
                                        characteristics[k]["value"] = item.id
                                    }
                                }
                            }
                        }
                    }

                    var subscriptionCharges = []
                    var effective_date = moment().format("MM/DD/YYYY HH:mm:ss")
                    var expiry_date = moment().add(103, 'years').format("MM/DD/YYYY HH:mm:ss")
                    if (item.ratingParameters && item.ratingParameters[0]) {
                        var ratingParam = item.ratingParameters[0]
                        if (item.productOfferingPrice[0].priceMode.id == "1") {
                            if (ratingParam && ratingParam.subscriptionPeriod) {
                                var subscriptionPeriod = parseInt(ratingParam.subscriptionPeriod)
                                if (ratingParam.subscriptionPeriodType.id == "0") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'days');
                                } else if (ratingParam.subscriptionPeriodType.id === "1") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'weeks');
                                } else if (ratingParam.subscriptionPeriodType.id === "2") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'Monthly');
                                } else if (ratingParam.subscriptionPeriodType.id === "3") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'years');
                                } else if (ratingParam.subscriptionPeriodType.id === "4") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'hours');
                                }
                            }
                        }
                    }

                    expiry_date = moment(expiry_date).format("MM/DD/YYYY HH:mm:ss")
                    for (var k = 0; k < item.productOfferingPrice.length; k++) {
                        var prorata_flags = ""
                        try {
                            var prorataEnabledInSuspension = item.productOfferingPrice[k].prorataEnabledInSuspension ? "1" : "0";
                            var prorataEnabledInTermination = item.productOfferingPrice[k].prorataEnabledInTermination ? "1" : "0";
                            var prorataEnabledInPlanChange = item.productOfferingPrice[k].prorataEnabledInPlanChange ? "1" : "0";
                            var prorataEnabledInActivation = item.productOfferingPrice[k].prorataEnabledInActivation ? "1" : "0";
                            prorata_flags = prorataEnabledInActivation + prorataEnabledInTermination + prorataEnabledInSuspension + prorataEnabledInPlanChange
                        } catch (err) {
                            prorata_flags = ""
                        }
                        var factor = ""
                        if (item.productOfferingPrice[k].factor) {
                            factor = item.productOfferingPrice[k].factor
                        }
                        var frequency = ""
                        if (item.productOfferingPrice[k].frequency) {
                            frequency = item.productOfferingPrice[k].frequency.id
                        }

                        let tempCharges = {}
                        try {
                            tempCharges = {
                                "upc_charge_id": item.productOfferingPrice[k].id,
                                "charge_type": item.productOfferingPrice[k].priceMode.id,
                                "charge_name": item.productOfferingPrice[k].name,
                                "charge_desc": item.productOfferingPrice[k].description,
                                "start_date": moment().format("MM/DD/YYYY HH:mm:ss"),
                                "end_date": expiry_date,
                                "charge_tax": item.productOfferingPrice[k].priceCode.taxCategoryId,
                                "charge_validity": "",
                                "charge_category": item.productOfferingPrice[k].priceCategory.billingChargeType.id,
                                "charge_id": item.id,
                                "discount_type": item.productOfferingPrice[k].priceType.name,
                                "epc_enabled": "1",
                                "quantity_based": "",
                                "charge_classification": "",
                                "charge_amount_type": item.productOfferingPrice[k].priceType.name,
                                "charge_frequency": frequency,
                                "charge_factor": factor,
                                "is_prorata": item.productOfferingPrice[k].prorataEnable ? "1" : "0",
                                "prorata_flags": prorata_flags,
                                "charge_code": item.productOfferingPrice[k].priceCode.id
                            }
                            if (connectionType === "POSTPAID") {
                                tempCharges["charge_amount"] = item.productOfferingPrice[k].price
                                tempCharges["total_charge"] = item.productOfferingPrice[k].price
                            } else {
                                tempCharges["charge_amount"] = "0"
                                tempCharges["total_charge"] = "0"
                            }
                        } catch (err) {
                            tempCharges = {}
                        }
                        subscriptionCharges.push(tempCharges)
                    }

                    var pogIdFromResponse = item.productOfferGroup.id;
                    var productFamilyIdFromResponse = item.productOfferGroup.productFamily.id

                    var currentAddonDataTemp = {};
                    currentAddonDataTemp["id"] = item["id"];
                    currentAddonDataTemp["name"] = item["marketingDescription"];
                    currentAddonDataTemp["description"] = item["description"] || "NA";
                    currentAddonDataTemp["offerAmount"] = productPrice.price || 0;
                    currentAddonDataTemp["effective_date"] = effective_date;
                    currentAddonDataTemp["expiry_date"] = expiry_date;
                    currentAddonDataTemp["productId"] = productOfferGroup.id;
                    currentAddonDataTemp["productName"] = productOfferGroup.name;
                    currentAddonDataTemp["poType"] = poType.id;
                    currentAddonDataTemp["subscriptionCharges"] = subscriptionCharges;
                    currentAddonDataTemp["contextValue"] = contextValue;
                    currentAddonDataTemp["pogIdFromResponse"] = pogIdFromResponse;
                    currentAddonDataTemp["eligibilityType"] = item.eligibilityType || 0;
                    currentAddonDataTemp["productFamilyIdFromResponse"] = productFamilyIdFromResponse;
                    currentAddonDataTemp["isRedeemable"] = isRedeemable;
                    currentAddonDataTemp["MinLoyaltyPoints"] = MinLoyaltyPoints;
                    currentAddonDataTemp["connectionType"] = connectionType;
                    currentAddonDataTemp["isMakePaymentAdjustment"] = isMakePaymentAdjustment;
                    currentAddonDataTemp["PaymentAmount"] = PaymentAmount;
                    currentAddonDataTemp["isMakeAdjustment"] = isMakeAdjustment;
                    currentAddonDataTemp["adjustmentAmount"] = adjustmentAmount;
                    if (cfssArray.length > 0) {
                        currentAddonDataTemp["cfss"] = cfssArray;
                    }
                    if(productSpecifications && productSpecifications.subType && productSpecifications.subType.id)
                    currentAddonDataTemp["po_sub_type"] = productSpecifications.subType.id || 0;
        
                    if(productSubtype && productSubtype.id)
                    currentAddonDataTemp["productSubtype"] = productSubtype.id || 0;
        
                }
                catch (err) {
                    currentAddonDataTemp = {}
                }
                var currentAddonData = encodeURIComponent(JSON.stringify(currentAddonDataTemp));

                var isFnfAddonPresent = "false"
                if (item.ratingParameters && item.ratingParameters[0]) {
                    isFnfAddonPresent = item.ratingParameters[0].friendsAndFamily;
                }

                var maxQuantity = "1"
                if (item.maxQuantity) {
                    maxQuantity = item.maxQuantity
                }

                var minQuantity = "0"
                if (item && item.minQuantity) {
                    minQuantity = item.minQuantity
                }
               
                if(parseInt(this.state.rewardPointsFromLMS) >= parseInt(MinLoyaltyPoints) && isFnfAddonPresent !== "true") {
                    isAddonPresent = true;
                    return (
                        <div className="col-md-6 mb-5" key={key}>
                            <div className="rewards-data-box py-3 allAddonDetailForAddonInactive">
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <div className="col-md-12 nameContainer">{item.marketingDescription}</div>
                                        <div className="col-md-12 nameContainerDesc">{item.description}</div>
                                    </div>
                                    <div className="p-3 nameContainer reward-points-div d-flex justify-content-center align-items-center flex-column"><div><div className="text-center" style={{ fontWeight: 500 }}>{MinLoyaltyPoints}</div><div className="text-center" style={{ fontSize: 12 }}>points</div></div></div>
                                </div>
                               
                                <div className="col-md-12 d-flex justify-content-end">
                                    <div className="rechargeCardActiveateBtn col-md-3 d-flex align-items-center justify-content-center" onClick={() => { this.rewardsRedeemBtnClicked(MinLoyaltyPoints,currentAddonData) }} >Redeem</div>
                                </div>
                            </div>
                        </div>
                    );
                }
            });
        })

        if (isAddonPresent) {
            return (<div className="allAddonDetailContainer row col-md-12 p-0 mx-auto">{allAddonDetails}</div>);
        } else {
            return (<div className="allAddonDetailContainer row m-0 col-md-12 p-0 mx-auto"><div className="col-md-12 mx-auto mt-3 row p-0"><NoDataFound content="No add-ons are available" /></div></div>);
        }
    }

    rewardsRedeemBtnClicked = (rewardPoints,currentAddonData) => {
        var offerDetails = JSON.parse(decodeURIComponent(currentAddonData));
        console.log("offerDetails>>>>",offerDetails)
        this.setState({ isLoading: true })
            var requestId = this.generateUniqueRequestId();
            var dataToSend = {
                "requestId": requestId,
                "serviceId": this.props.cache.serviceInfo.serviceId,
                "rewardPoints": rewardPoints,
                "productId": offerDetails.id,
                "productName": offerDetails.name
            }
            Network.executeAxios("reservePoints", "POST", dataToSend, (reserveResponse) => {
               if(reserveResponse.respCode == "SC0000"){
                if(offerDetails.isMakePaymentAdjustment && this.props.cache.serviceInfo.connectionType === this.props.locales.connectionTypeForPostpaid){
                    var dataToSend = {
                        "accountId": this.state.contactDetails.accountId,
                        "profileId": this.state.profileId,
                        "amount": offerDetails.PaymentAmount,
                        "customerName": this.state.customerName,
                        "contactNum": this.state.contactNumber
                    }
                    Network.executeAxios("paymentAdjust", "POST", dataToSend , (resp) => {
                        if(resp && resp.dataset &&  resp.dataset.param && resp.dataset.param[0] && resp.dataset.param[0].id && resp.dataset.param[0].id !== ""){
                            this.handleAddSubscriptionResponse(requestId, offerDetails.name, resp);
                        } else {
                             this.setState({ isLoading: false })
                             Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
                        }
                     })
                } else  if(offerDetails.isMakeAdjustment && this.props.cache.serviceInfo.connectionType === this.props.locales.connectionTypeForPrepaid){
                    var dataToSend = {
                        "accountId": this.state.contactDetails.accountId,
                        "profileId": this.state.profileId,
                        "amount": offerDetails.adjustmentAmount,
                        "customerName": this.state.customerName,
                        "contactNum": this.state.contactNumber,
                        "serviceId": this.props.cache.serviceInfo.serviceId,
                        "serviceTypeId": this.props.cache.serviceInfo.serviceTypeId
                    }
                    Network.executeAxios("makeAdjustment", "POST", dataToSend , (resp) => {
                        if(resp && resp.dataset &&  resp.dataset.param && resp.dataset.param[0] && resp.dataset.param[0].id && resp.dataset.param[0].id !== ""){
                            this.handleAddSubscriptionResponse(requestId, offerDetails.name, resp);
                        } else {
                             this.setState({ isLoading: false })
                             Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
                        }
                     })
                } else {
                    this.generateAddonFinalRequest(requestId,offerDetails,rewardPoints);
                }
                  
               } else {
                    this.setState({ isLoading: false })
                    Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
               }
            })
       
    }

    generateAddonFinalRequest(requestId, receivedAddonDetails,rewardPoints) {
        var servicesSubscription = [];
        var effective_date = receivedAddonDetails.effective_date;
        var effective_date_formatted = ""
        if (effective_date !== "" && effective_date !== undefined) {
            effective_date_formatted = effective_date;
        }
        else {
            effective_date_formatted = moment().format(this.props.configurationValues.dateFormatForBilling)
        }

        var expiry_date = receivedAddonDetails.expiry_date;
        var expiry_date_formatted = ""
        if (expiry_date != "" && expiry_date != undefined) {
            expiry_date_formatted = expiry_date;
        }
        else {
            expiry_date_formatted = moment().add(103, 'years').format(this.props.configurationValues.dateFormatForBilling)
        }
        var addonsSubscriptions =
        {
            "product_id": receivedAddonDetails.productId,
            "product_name": receivedAddonDetails.productName,
            "plan_id": receivedAddonDetails.id,
            "plan_name": receivedAddonDetails.name,
            "plan_desc": receivedAddonDetails.description,
            "effective_date": effective_date_formatted,
            "expiry_date": expiry_date_formatted,
            "is_base_plan": "0",
            "po_type": receivedAddonDetails.poType,
            "po_sub_type": "0",
            "subscription_type": "0",
            "subscription_charges": receivedAddonDetails.subscriptionCharges,
            "cfss": receivedAddonDetails.cfss,
            "pogIdFromResponse": receivedAddonDetails.pogIdFromResponse,
            "apply_purchase_fee":"false",
            "activate_addon_upon_use": "false",
            "status": "0",
            "plan_type": "2",
            "version": "3"
        }
        servicesSubscription.push(addonsSubscriptions);

        var finalOrderReq = {
            "order_information": {
                "order_type": "AddSubscription",
                "customer_name": this.state.customerName,
                "contact_number": this.state.contactNumber,
                "service_management": {
                    "service_id": this.props.cache.serviceInfo.serviceId,
                    "profile_id": this.state.profileId,
                    "account_id": this.state.contactDetails.accountId,
                    "service_name": this.state.contactDetails.serviceName,
                    "service_code": this.state.contactDetails.serviceCode,
                    "subscriptions": servicesSubscription,
                    "service_address": {
                        "addr_line1": this.props.cache.serviceListResponse[0].addresses[0].addr_line1,
                        "addr_line2": this.props.cache.serviceListResponse[0].addresses[0].addr_line2,
                        "addr_line3": this.props.cache.serviceListResponse[0].addresses[0].addr_line3,
                        "addr_line4": this.props.cache.serviceListResponse[0].addresses[0].addr_line4,
                        "addr_line5": this.props.cache.serviceListResponse[0].addresses[0].addr_line5,
                        "addr_line6": ""
                    }
                },
                "dataset": {
                    "param": [
                        {
                            "id": "entity_id",
                            "value": "200"
                        }
                    ]

                }
            }
        }

        if (parseInt(rewardPoints) > 0) {
            finalOrderReq["order_information"]["service_management"]["loyalty_info"] = {
                "lms_txn_id": requestId
            }
        }

        var addSubscriptionDataToSend = {
            "finalReq": finalOrderReq,
            "addSubscriptionType": "redeemPlan"
        }
     
        Network.executeAxios("addSubscription", "POST", addSubscriptionDataToSend, (response) => {
            this.handleAddSubscriptionResponse(requestId, receivedAddonDetails.name, response);
        });
    }

    handleAddSubscriptionResponse(requestId, planName, response) {
        //this.setState({isLoading: true})
        var isSuccess = false;
        try {
            if (response.result_code == "0") {
                isSuccess = true;
            }
        } catch (err) { isSuccess = false }
        if (isSuccess) {
            Network.executeAxios("commitPoints", "POST", {requestId : requestId, planName : planName, serviceId : this.props.cache.serviceInfo.serviceId}, (commitResponse) => {
               // this.setState({ isLoading: false })
                if(commitResponse.respCode == "SC0000"){
                    Swal.fire({
                        title: this.props.locales.rewardsRedeemPlanSuccessText,
                        type: '',
                        showCancelButton: false,
                        confirmButtonText: 'Ok'
                    }).then((result) => {
                        if (result.value) {
                           this.componentDidMount();
                        }
                    });
                }else {
                    this.setState({isLoading: false})
                    Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
                }
             })
        } else {
            Network.executeAxios("rollbackPoints", "POST", {requestId : requestId, serviceId : this.props.cache.serviceInfo.serviceId }, (rolbackResponse) => {
                this.setState({ isLoading: false })
                if(rolbackResponse.respCode == "SC0000"){
                    // Swal.fire({
                    //     title: this.props.locales.rewardsRedeemPlanSuccessText,
                    //     type: '',
                    //     showCancelButton: false,
                    //     confirmButtonText: 'Ok'
                    // }).then((result) => {
                    //     if (result.value) {
                    //         document.body.classList.remove('modal-open');
                    //         this.setState({ redeemRewardsModalVisible: false })
                    //         window.location.reload();
                    //     }
                    // });
                    console.log("rollback success");
                    Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
                }else {
                    console.log("rollback failed");
                    Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
                }
             })
        }
    }

    generateUniqueRequestId = () => {
        var requestId = "SCM" + "1" + moment().valueOf() + Math.floor(10 + Math.random() * 90);
        //Request ID format -  SCM + 1 + 15 digit sequence number 
        return requestId;
    };


    generalBtnClicked(type){
        this.setState({currentTab: type})
    }


    initialiseQuerySubscriber(){
        var reduxCache = this.props.cache;
        try {
            var receivedResponse = reduxCache.querySubscriberResponse;
            var params = receivedResponse.profile_info.basic_details;
            var finalContactNumber = "";
            var finalFirstName = "";
            var finalLastName = "";
            
            for (var i = 0; i < params.length; i++) {
                if (params[i].id === "first_name") {
                    finalFirstName = params[i].value;
                }
                if (params[i].id === "last_name") {
                    finalLastName = params[i].value;
                }
                if (params[i].id === "contact_number_1") {
                    finalContactNumber = params[i].value;
                }
            }
            this.setState({
                contactNumber: finalContactNumber,
                customerName: finalFirstName+ " "+ finalLastName
            })

        } catch (err) {

        }
    }


    rewardsRegisterBtnClicked = () => {
        document.body.classList.add('modal-open');
        this.setState({ rewardsTermsAndConditionsVisible: true })
    }


    rewardsTransactionsTableHandler = (dataObject) => {
        console.log("dataObject >>", dataObject);
        if (dataObject.type === "firstTimeLoad" || dataObject.type === "pagination") {
            this.setState({ "dummy": "dummy" });
        }
    }



    rewardsTAndCModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ rewardsTermsAndConditionsVisible: false })
        } else if (dataObject.type === "submit") {
            this.setState({isLoading: true})
            Network.executeAxios("loyalityUserRegistration", "POST", { "serviceId": this.state.serviceId, "customerName": this.state.customerName, "contactNumber": this.state.contactNumber }, (receivedResponse) => {
                this.setState({isLoading: false})
                if (receivedResponse.result_code === "0") {
                    this.setState({ isAlreadyRegisteredForRewards: true })
                    Swal.fire({
                        title: "Loyality Registration Success",
                        text: "",
                        type: '',
                        timer: 2000,
                        showCancelButton: false,
                        confirmButtonText: 'Ok',
                    }).then((result) => {
                        document.body.classList.remove('modal-open');
                        this.setState({ rewardsTermsAndConditionsVisible: false })
                        this.getRewardPoints();
                    });


                } else {
                    this.setState({ isAlreadyRegisteredForRewards: false })
                    Swal.fire(this.props.locales.loyaltyRegFailureSwal);
                    document.body.classList.remove('modal-open');
                }
            })
        }
    }


    render() {
        return (
            <div className="col-md-12 animated fadeIn justify-content-center p-0 m-0">
              

                <div id="RechargeComponentContainer">
                    {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : null}
                   <div className='col-md-12 p-0 m-auto' style={{width: '92%'}}>
                   {this.renderContentPart()}
                   </div>
                  
                </div>


            </div>
        );
    }

    renderRechargeContentPart() {
        return (<div className='col-md-12 m-0 p-0' style={{flex: 1}}>
            <div className='col-md-12 row justify-content-md-between justify-content-center m-0 pb-3' style={{flex:1}}>
                <div></div>
                <div className='d-flex'>
                    <div className={this.state.currentTab === "bundles" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("bundles") }}>Bundles</div>
                    <div className={this.state.currentTab === "recharge" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("recharge") }}>Recharge</div>
                </div>
                <div className='align-items-center'>
                    <div className='brandColorButtonContainer p-2 px-4 m-1'> <div className='buttonTxtSmall'>Active</div> <div className='buttonTxtSmall'>Bundles</div>  </div>
                </div>
            </div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
            <div>sdfsdfdsf</div>
        </div>)
    }

    renderTest(){
      return ( <div className='col-md-12 m-0 p-0' style={{flex: 1}}>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf</div>
            <div>sdfsdf444</div>
        </div>)
    }

    renderContentPart() {
        return (<div className='col-md-12 m-0 p-0' style={{}}>
             {this.state.isAlreadyRegisteredForRewards ? 
            <div className='col-md-12 d-flex justify-content-center' style={{}}>
                <div className='d-flex'>
                    <div className={this.state.currentTab === "rewards" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("rewards") }}>Rewards</div>
                    <div className={this.state.currentTab === "transactions" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("transactions") }}>Transactions</div>
                </div>
            </div> 
            : null
            }
            {this.state.currentTab === "rewards"? 
            // <div className='cardOuterContainer col-md-12 p-4' style={{ maxHeight:(window.innerHeight - 350 )+"px",overflow:"scroll"}}>
            <div> 
                {this.state.isAlreadyRegisteredForRewards ?
                    <div>
                        <div className='d-flex'><div className='totalRewardTxt'>Total Reward Points:</div> <div className='rewardPoint pl-1'>{' '}{this.state.rewardPointsFromLMS}</div> </div>
                        <div className='dividerLine my-2'></div>
                    
                        <div className='col-md-12 row justify-content-between m-0 p-0'>
                            {this.populateAllRedeemablePlans()}
                        </div>
                    </div>
                :
                    <div className='d-flex justify-content-center align-items-center'>
                        <div className='totalRewardTxt'>Register for APUA inet's rewards program</div> &nbsp; &nbsp;
                        <div className='blueButtonContainer px-3' onClick={() => this.rewardsRegisterBtnClicked()}>Register</div>
                    </div>
                }

            </div>
            :
            // <div className='cardOuterContainer col-md-12 row justify-content-between m-0' style={{ maxHeight:(window.innerHeight - 350 )+"px",overflow:"scroll"}}>
           <div>
            {this.transactionsCard()}
            </div>
            }
            <SliderModal
                    isVisible={this.state.rewardsTermsAndConditionsVisible}
                    uniqueModalReferenceId="rewardsTermsAndConditions"
                    mainHeading="Terms And Conditions"
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    submitButtonText="Agree"
                    callback={this.rewardsTAndCModalHandler}
                >
                    <div className="col-md-12 px-2" style={{ height: '100%' }} >
                        <iframe title="" src="./rewardsTAndC.html" style={{ width: '100%', height: '100%', border: 'none' }} frameBorder="0"> </iframe>
                    </div>

                </SliderModal>

            
        </div>)
    }

    transactionsCard(){
        return(
            <TableComponent
                            headerArray={[
                                {
                                    key: "date",
                                    label: "Transaction Date"
                                },
                                {
                                    key: "type",
                                    label: "Type",
                                    // formatter: (rowData, callback) => {
                                    //     var text = rowData.type;
                                    //     text = text.split("-")[0];
                                    //     var activity = rowData.activity;
                                    //     if(text.indexOf("Redeemed") > -1){
                                    //         text = text + " for "+activity;
                                    //     } 
                                    //     return (
                                    //         <div className="">
                                    //             {text}
                                    //         </div>
                                    //     )
                                    // }
                                },
                                {
                                    key: "loyalty_points",
                                    label: "Total Rewards Points"
                                },
                                {
                                    key: "expiry_points",
                                    label: "Expiry Points"
                                },
                                {
                                    key: "expiry_date",
                                    label: "Expiry Date"
                                }
                            ]}
                            payload={this.state.rewardsTransactionsData}
                            isSearchRequired={true}
                            noDataContentText="No Rewards Transactions Found"
                            limit={5}
                            tableUniqueId="rewardsTransactionsTable"
                            callback={this.rewardsTransactionsTableHandler}
                        />

        )
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails,
        configurationValues: state.configurationValues,
        registerDetails: state.registerDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        }
    }
}

const RewardsComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RewardsPageComponent)

export default RewardsComponentContainer;
